import fetch from "../axiosConfig";

//----------------模板---------------------
/**
 * 我的模板列表
 * @returns
 */
export function findTemplateList(data) {
    return fetch({
        url: "/template/findMyTemplateList",
        method: "post",
        data
    });
}

/**
 * 模板列表
 * @returns
 */
 export function getTemplateList(data) {
    return fetch({
        url: "/template/findTemplateList",
        method: "post",
        data
    });
}

/**
 * 模板-省区引用地区
 * @returns
 */
 export function referTemplate(data) {
    return fetch({
        url: "/template/referTemplate",
        method: "post",
        data
    });
}

/**
 * 模板-省区提交
 * @returns
 */
 export function provinceTemplateSubmit(data) {
    return fetch({
        url: "/template/provinceTemplateSubmit ",
        method: "post",
        data
    });
}

/**
 * 查询模板分组
 * @param {*} data {name: "",prescriptionType: 处方类型 1贴敷,templateType: 模板类型 1省区模板 2 地区模板}
 * @returns
 */
export function findTemplateTypeList(data) {
    return fetch({
        url: "/templateType/findTemplateTypeList",
        method: "post",
        data
    });
}

/**
 * 查询分组模板列表
 * @param {*} data
 * @returns
 */
export function findGroupTemplateList(data) {
    return fetch({
        url: "templateType/findTemplateList",
        method: "post",
        data
    });
}

export function findMyTemplateList(data) {
  return fetch({
      url: "templateType/findMyTemplateList",
      method: "post",
      data
  });
}

/**
 * 添加模板分组
 * @param {*} data
 * @returns
 */
export function addTemplateType(data) {
    return fetch({
        url: "/templateType/addTemplateType",
        method: "post",
        data
    });
}

/**
 * 修改模板分组名称
 * @param {*} data
 * @returns
 */
export function updateTemplateType(data) {
    return fetch({
        url: "/templateType/updateTemplateType",
        method: "post",
        data
    });
}

/**
 * 删除模板分组
 * @param {*} data
 * @returns
 */
export function deleteTemplateType(data) {
    return fetch({
        url: "/templateType/deleteTemplateType",
        method: "post",
        data
    });
}

/**
 * 查询模板详情
 * @param {*} data
 * @returns
 */
export function findTemplateDetail(data) {
    return fetch({
        url: "/template/findTemplateDetail",
        method: "post",
        data
    });
}

/**
 * 查询我的模板详情
 * @param {*} data
 * @returns
 */
export function findMyTemplateDetail(data) {
    return fetch({
        url: "/template/findMyTemplateDetail",
        method: "post",
        data
    });
}
/**
 * (添加 无模板ID参数 | 编辑 有模板ID参数)保存我的模板
 * @param {]} data
 * @returns
 */
export function saveTemplate(data) {
    return fetch({
        url: "/template/saveTemplate",
        method: "post",
        data
    });
}


/**
 * (添加 无模板ID参数 | 编辑 有模板ID参数)提交我的模板
 * @param {]} data
 * @returns
 */
export function addTemplate(data) {
    return fetch({
        url: "/template/addTemplate",
        method: "post",
        data
    });
}

/**
 * 删除模板
 * @param {*} data
 * @returns
 */
export function deleteTemplate(data) {
    return fetch({
        url: "/template/deleteTemplate",
        method: "post",
        data
    });
}

/**
 * 删除我的模板
 * @param {*} data
 * @returns
 */
 export function deleteMyTemplate(data) {
    return fetch({
        url: "/template/deleteMyTemplate",
        method: "post",
        data
    });
}
//----------------药品---------------------
/**
 * 查询公库药品
 * @param {*} data
 * @returns
 */
export function outpatientFindListPublic(data) {
    return fetch({
        url: "/medicine/outpatientFindListPublic",
        method: "post",
        data,
    });
}

/**
 * 查询消肿止痛贴药品信息
 * @returns
 */
export function outpatientFindStick() {
    return fetch({
        url: "/medicine/outpatientFindStick",
        method: "get",
    });
}

/**
 * 查询穴位
 * @returns
 */
export function findAcupoints() {
    return fetch({
        url: "/consulting/findAcupoints ",
        method: "post",
    });
}



// WEBPACK FOOTER //
// ./src/api/template/template.js